import Axios from '@/store/axios'
var Promise = require('bluebird')

  const initialState = () => ({
    configurable_options: {
      operating_systems: [],
      cores: [1, 2, 3, 4, 5, 6],
      core_rate: 4,
      ram: [2, 4, 8, 16, 32, 64, 128],
      ram_rate: 1.5,
      storage_rate: .05
    },
    virtual_machines: []
  });

  const state = initialState();
  const getters = {
    getVMById: (state) => (id) => {
      return state.virtual_machines.find( (vm) => vm._id === id)
    },
    getVMBackupsById: (state) => (id) => {
      return state.virtual_machines.find( (vm) => vm._id === id).backups
    }
  }
  const mutations = {
    SET_VIRTUAL_MACHINES : (state, virtual_machines) => {
      state.virtual_machines = virtual_machines;
    },
    UPDATE_VIRTUAL_MACHINE : (state, vm) => {
      var index = state.virtual_machines.findIndex( current_vm => current_vm._id === vm._id);
      if(index)
        state.virtual_machines[index] = vm
    },
    SET_CONFIGURABLE_OPTIONS : (state, configurable_options) => {
      // later this will be more generic and we will pull all config options from our API, but for now it's just for operating systems
      state.configurable_options = { ...state.configurable_options, ...configurable_options }
    },
    RESET: (state) => {
      const newState = initialState();
      Object.keys(newState).forEach( key => {
        state[key] = newState[key]
      });
    }
  }
  const actions = {
    CREATE_VIRTUAL_MACHINE : (context, vm) => {
      return Promise.try( () => {
        let vm_with_defaults = {
          bandwidth: "1"
        }
        vm_with_defaults = { ...vm_with_defaults, ...vm }
        return Axios.post(`vms`, vm_with_defaults)
      }).then( (vm_id) => {
        context.dispatch('POLL_VIRTUAL_MACHINE', vm_id.data) // don't return the dispatch, we need to return immediately and run poll in background to redirect
        return
      })
    },
    DELETE_VIRTUAL_MACHINE : (context, id) => {
      return Promise.try( () => {
        return Axios.delete(`vms/${id}`)
      })
    },
    GET_VIRTUAL_MACHINE : (context, id) => {
      return Promise.try( () => {
        return Axios.get(`vms/${id}`)
      }).then( (vm) => {
        if(vm) {
          if(vm.data.hostname)
            vm.data.hostname = vm.data.hostname.slice(0, -13)
          context.commit('UPDATE_VIRTUAL_MACHINE', vm.data)
        }
        return vm
      })
    },
    GET_VIRTUAL_MACHINES : (context) => {
      return Promise.try( () => {
        return Axios.get(`vms`)
      }).then( (virtual_machine_list) => {
        if(virtual_machine_list.data.length > 0) {
          const new_vm_array = virtual_machine_list.data.map( vm => ( {...vm, hostname: vm.hostname.slice(0, -13) })); // slice out our hostname unique identifier
          context.commit('SET_VIRTUAL_MACHINES', new_vm_array);
        } else {
          context.commit('SET_VIRTUAL_MACHINES', []);
        }
        return
      })
    },
    POLL_VIRTUAL_MACHINE : (context, id) => {
      let poll_interval = setInterval( ()=> {
        context.dispatch('GET_VIRTUAL_MACHINE', id)
          .then( (vm) => {
            if(vm.state == 'running')
              clearInterval(poll_interval);
          });
      }, 3000);
    },
    GET_VIRTUAL_MACHINE_PASSWORD : (context, id) => {
      return Promise.try( () => {
        return Axios.get(`vms/${id}/password`)
      }).then( (password) => {
        return password.data
      })
    },
    CHANGE_VIRTUAL_MACHINE_STATE : (context, { id, state }) => {
      return Promise.try( () => {
        return Axios.post(`vms/${id}/${state}`)
      }).then( () => {
        return context.dispatch('GET_VIRTUAL_MACHINE', id);
      })
    },
    BACKUP_VIRTUAL_MACHINE : (context, { id, name }) => {
      return Promise.try( () => {
        if( name != null)
          return Axios.post(`vms/${id}/backups/${name}`)
      }).then( () => {
        return context.dispatch('GET_VIRTUAL_MACHINE', id)
      })
    },
    DELETE_VIRTUAL_MACHINE_BACKUP : (context, { id, backup_id }) => {
      return Promise.try( () => {
        return Axios.delete(`vms/${id}/backups/${backup_id}`)
      }).then( () => {
        return context.dispatch('GET_VIRTUAL_MACHINE', id)
      })
    },
    RESTORE_VIRTUAL_MACHINE_BACKUP : (context, { id, backup_id }) => {
      return Promise.try( () => {
        return Axios.post(`vms/${id}/backups/${backup_id}/restore`)
      })
    },
    GET_CONFIGURABLE_OPTIONS : (context) => {
      return Promise.try( () => {
        return Axios.get('vms/operating_systems')
      }).then( (operating_systems) => {
        let configurable_options = {
          operating_systems: operating_systems.data
        }
        context.commit('SET_CONFIGURABLE_OPTIONS', configurable_options)
        return
      })
    }
  }

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
